import React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import { useTheme } from "@mui/material/styles";

// import { FormField } from "../../particles/formFieldRHF";
// import { LabelTooltip } from "../../organisms/labelTooltip";
// import { NotificationCard } from "../../organisms/notificationCard";

import { NotificationCard } from "../notificationCard";

import { FormField, LabelTooltip } from "@arp/react-ndbx";

import {
	FormControl,
	FormHelperText,
	TextField as MUITextField,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

//----------------------------------------------------------------

const RHFTextField = React.forwardRef((props, ref) => (
	<FormField ref={ref} Component={RHFTextFieldImpl} {...props} />
));

const RHFTextFieldImpl = React.forwardRef(
	(
		{
			name,
			variant = "standard",
			label,
			size,
			controlIdentifier,
			ariaLabel,
			defaultValue,
			onChange,
			onBlur,
			onFocus,
			error,
			helperText,
			subPlaceHolder = null,
			showTooltip = false,
			tooltipText = "PLEASE ADD TOOLTIP TEXT!",
			showErrorCard = true,
			extendedError = { title: null, additionalText: null },
			readOnly = false,
			disablePaste = false,
			...props
		},
		ref
	) => {
		const inputId = name?.replace(".", "-");
		const useStyles = makeStyles()((theme) => {
			return {
				root: {
					marginLeft: "auto",
					fontFamily: "Allianz Neo",
					fontSize: 10,
					color: theme.palette.greyscale.Grey500,
					marginTop: 0.5,
					marginBottom: 1,
				},
			};
		});

		const handlePaste = (event) => {
			if (disablePaste === false) return; // Allow paste if false

			event.preventDefault(); // Prevent pasting
		};

		const { classes } = useStyles();
		const theme = useTheme();

		return (
			<FormControl sx={{ width: "100%" }} size={size} error={error}>
				<MUITextField
					data-identifier={`textfield-${controlIdentifier}`}
					aria-label={ariaLabel}
					className="subvariant-text-input"
					name={name}
					id={inputId}
					defaultValue={defaultValue}
					variant={variant}
					onBlur={onBlur}
					onFocus={onFocus}
					onChange={onChange}
					onPaste={handlePaste}
					error={error}
					label={label}
					ref={ref}
					fullWidth
					helperText={subPlaceHolder}
					FormHelperTextProps={{
						classes: {
							root: classes.root,
						},
					}}
					InputProps={{
						endAdornment: showTooltip ? (
							<InputAdornment position="end">
								<LabelTooltip
									controlIdentifier={controlIdentifier}
									tooltipTitle={tooltipText}
								/>
							</InputAdornment>
						) : null,
						readOnly: readOnly,
					}}
					{...props}
				/>
				{helperText && showErrorCard === true && (
					<NotificationCard
						sx={{ mt: 1 }}
						message={helperText}
						{...extendedError}
					/>
				)}
				{helperText && showErrorCard === false && (
					<FormHelperText sx={{ color: theme.palette.signal.Error600 }}>
						{helperText}
					</FormHelperText>
				)}
			</FormControl>
		);
	}
);

export default RHFTextField;
